import { render, staticRenderFns } from "./ContenidoCapacitacion.vue?vue&type=template&id=72df653c"
import script from "./ContenidoCapacitacion.vue?vue&type=script&lang=js"
export * from "./ContenidoCapacitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports